var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rectangle_svg__clip0_4244_29137)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1B264F",
    d: "M28.055 10.625l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8E0FF",
    d: "M40.64 23.211l4.757 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324489",
    d: "M34.344 16.918l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B264F",
    d: "M21.766 16.918l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BAEF1",
    d: "M34.352 29.504l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324489",
    d: "M28.055 23.211l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B264F",
    d: "M15.469 23.211l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506BCA",
    d: "M28.055 35.797l4.756 4.756-4.756 4.756-4.756-4.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324489",
    d: "M21.758 29.504l4.756 4.756-4.756 4.756-4.756-4.756z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rectangle_svg__clip0_4244_29137"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(45 2.073 38.474)",
    d: "M0 0h26.087v25H0z"
  })))));
}
export default __webpack_public_path__ + "media/homeProperty/rectangle-5f413d26.svg";
export { SvgRectangle as ReactComponent };